var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.5C24.7532 32.5 32 25.2371 32 16.5C32 7.74681 24.7371 0.5 15.9844 0.5C7.24731 0.5 0 7.74681 0 16.5C0 25.2371 7.26287 32.5 16 32.5ZM10.4629 23.3392C9.75711 23.3392 9.17635 22.7429 9.17635 22.0216C9.17635 21.6762 9.3179 21.3625 9.55282 21.1115L14.1493 16.5156L9.55282 11.9196C9.3179 11.6686 9.17635 11.3549 9.17635 11.0096C9.17635 10.2882 9.75711 9.72353 10.4629 9.72353C10.8393 9.72353 11.1375 9.84902 11.3724 10.1L15.9844 14.696L20.6431 10.0844C20.9097 9.81739 21.1923 9.69191 21.5371 9.69191C22.2434 9.69191 22.8237 10.2722 22.8237 10.9784C22.8237 11.3393 22.7137 11.6215 22.4472 11.9036L17.8352 16.5156L22.4316 21.096C22.6826 21.3625 22.8081 21.6607 22.8081 22.0216C22.8081 22.7429 22.2273 23.3392 21.506 23.3392C21.1451 23.3392 20.8314 23.1821 20.5804 22.9467L15.9844 18.3507L11.4196 22.9467C11.1686 23.1977 10.8393 23.3392 10.4629 23.3392Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMark);
export default __webpack_public_path__ + "static/media/CloseMark.d77246eb959bad5e70310f2b7063d3fd.svg";
export { ForwardRef as ReactComponent };